(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ru-partner-logos"] && !Shopify.designMode) return;
  try {
    
  class RuPartnerLogos extends HTMLElement {
    connectedCallback() {
      this.#slideshow = this.querySelector('slideshow-component');
      if (!this.#slideshow) return;

      this.#scroller = this.#slideshow.querySelector('slideshow-slides');
      if (!this.#scroller) return;

      this.#update = () => {
        const overflows = this.#scroller.scrollWidth > this.#scroller.clientWidth + 2;
        this.toggleAttribute('data-carousel-active', overflows);
      };

      this.#resizeObserver = new ResizeObserver(this.#update);
      this.#resizeObserver.observe(this.#scroller);
      this.#resizeObserver.observe(this);

      requestAnimationFrame(() => {
        requestAnimationFrame(this.#update);
      });

      this.#slideshow.addEventListener('scroll', this.#update, { passive: true });
    }

    disconnectedCallback() {
      this.#resizeObserver?.disconnect();
    }

    #slideshow;
    #scroller;
    #resizeObserver;
    #update;
  }

  if (!customElements.get('ru-partner-logos')) {
    customElements.define('ru-partner-logos', RuPartnerLogos);
  }

  } catch(e) { console.error(e); }
})();
})();
